import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../AiGovernance/AiGovernance.css';
import './isms.css';

const TABS = [
  { to: '/dashboard/isms',       i18n: 'Isms.tabOverview', label: 'Overview', exact: true },
  { to: '/dashboard/isms/roles', i18n: 'Isms.tabRoles',    label: 'Roles & Owner' },
  { to: '/dashboard/isms/risks', i18n: 'Isms.tabRisks',    label: 'Risk Register' },
  { to: '/dashboard/isms/soa',   i18n: 'Isms.tabSoa',      label: 'Statement of Applicability' },
];

// Shared tab header for the ISMS workspace; the active tab comes from the route.
export default function IsmsNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const active = (tab) => (tab.exact ? pathname === tab.to || pathname === `${tab.to}/` : pathname.startsWith(tab.to));
  return (
    <div className="aig-tabs">
      {TABS.map((tab) => (
        <button key={tab.to} type="button" className={`aig-tab ${active(tab) ? 'aig-tab-active' : ''}`} onClick={() => navigate(tab.to)}>
          {t(tab.i18n, tab.label)}
        </button>
      ))}
    </div>
  );
}
